module.exports = __webpack_public_path__ + "static/img/shiye.6e73eb5c.png";